export * from './rating.module';
//# sourceMappingURL=index.js.map